export const getTranslation = () => {
    return acp_cf_settings_i18n;
};
